import moment from 'moment';

export const DateTimeH = {};

DateTimeH.dateTimeToDate = function(dateTime) {
    return moment(dateTime, "YYYY-MM-DD HH:mm:ss", true).format("YYYY-MM-DD");
};